
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { CstFormBuilder, CstFormGroup } from "src/app/_uncategorised_models_services/cst-form-group";
import { WawiApiNoteFacilityExtendedFilterModel } from "./note-facility-extended-filter.model";
import { IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { NoteDisplayLevel } from "src/app/web-api/web-api";


@Component({
    selector: "app-wawi-note-facility-filter-component",
    templateUrl: "./note-facility-extended-filter.component.html",
    styles: [""],
    standalone: false
})

export class WawiApiNoteFacilityExtendedFilterComponent {
    dialogRef = inject<MatDialogRef<WawiApiNoteFacilityExtendedFilterComponent>>(MatDialogRef);
    data = inject<WawiApiNoteFacilityExtendedFilterModel>(MAT_DIALOG_DATA);

    public form: CstFormGroup<WawiApiNoteFacilityExtendedFilterModel>;

    public selectedNoteDisplayLevelFilter = undefined;
    public showReceiptFilter = false;
    private showAllEntryTypesFilter = 999;

    public entryTypeFiltersAvailable: Array<IFormDropDownItem> = [
        {
            label: $localize`:@@selectedNoteDisplayLevelFilter_undefined:Alle anzeigen`,
            value: this.showAllEntryTypesFilter,
        }, 
        {
            label: $localize`:@@NoteDisplayLevel_Standard:Standard`,
            value: NoteDisplayLevel.Standard,
        },
        {
            label: $localize`:@@NoteDisplayLevel_Hervorgehoben:Hervorgehoben`,
            value: NoteDisplayLevel.Hervorgehoben,
        },
        {
            label: $localize`:@@NoteDisplayLevel_AktivAnzeigen:Aktiv anzeigen`,
            value: NoteDisplayLevel.AktivAnzeigen,
        },
    ];

    constructor() {
        const data = this.data;
        const fb = inject(CstFormBuilder);

        this.form = fb.group<WawiApiNoteFacilityExtendedFilterModel>({
            eventFilter: new FormControl(data.eventFilter)
        })
        this.form.valueChanges.subscribe((value) => {
            this.data = value;
        });
    }

    public getLabelForEventType(eventType: number): string {
        for (const e of this.entryTypeFiltersAvailable) {
            if (e.value === eventType) {
                return e.label;
            }
        }
        return "";
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

 
}